<template>
  <div
    :id="`m-value-wrapper|${label}|${uuid}`"
    :data-label="label"
    class="dm-rounded dm-label dm-flex"
    :class="{ 'dm-bgsel': isSelected('/l'), 'dm-bgpart': inSelection('/l') }"
  >
    <div :id="`m-value|${label}|${uuid}`" class="dm-rounded" @click="select('/l')">
      {{ label }}:
    </div>
    <div v-if="value == null" class="dm-rounded">null</div>
    <div
      v-else
      class="dm-rounded dm-val"
      @click="select('/v')"
      :class="{ 'dm-bgsel': isSelected('/v'), 'dm-bgpart': inSelection('/v') }"
    >
      {{ value }}
    </div>

    <v-icon title="Copy to clipboard" @click="copyToClipboard" size="13"
      >fa-copy</v-icon
    >
    <apio-snackbar :text="snackBarText" :status="snackBarStatus" :snackbar="snackbar" @close="snackbar = false" />
  </div>
</template>

<script>
import * as clipboard from "clipboard-polyfill/text";
var uuid = require("uuid");

export default {
  name: "MValue",
  props: ["label", "value", "prefix", "rprefix", "sel"],
  data() {
    return {
      ok: false,
      snackbar: false,
      snackBarText: '',
      snackBarStatus: null,
    };
  },
  computed: {
    uuid() {
      return uuid.v4()
    },
  },
  methods: {
    async copyToClipboard() {
      const vm = this;
      await clipboard.writeText(this.value).then(
        function () {
          vm.snackBarText = 'Copied to clipboard';
          vm.snackBarStatus = 'success';
          vm.snackbar = true;
        },
        function () {
          vm.snackBarText = 'Could not copy value to the clipboard';
          vm.snackBarStatus = 'error';
          vm.snackbar = true;
        }
      );
    },
    select(suffix) {
      this.$root.$emit("selected", {
        label: this.label,
        selected: this.rprefix + suffix,
        path: this.prefix + suffix,
      });
    },
    isSelected(suffix) {
      return this.sel.selected == this.rprefix + suffix;
    },
    inSelection(suffix) {
      if (this.sel.selection == null) return false;
      return this.sel.selection.includes(this.rprefix + suffix);
    },
  },
};
</script>
